const MacroCategoryOrder = {
    overall: {
        customOrder: ["Overall Opinion", "Efficacy", "Fragrance", "Sensory & Application", "Stains", "Skin Care", "Packaging"],
        customOrderOralCare: ["Overall Opinion", "Flavor / Taste", "Freshness", "Cleaning", "Protection / Strengthening", "Others", "Appearance", "Texture"],
        customOrderSkinCleansing: ["Overall Opinion", "Overall Fragrance", "Overall Lather", "Overall Texture", "Overall Colour", "Overall Appearance", "Overall Packaging"],
        customOrderUnileverFragranceHouse: ["Overall Opinion", "Emotional Product Attributes", "Fragrance Strength"],
        customSubOrderOralCare: [
            "R_OO",
            "R_OO_7pt",
            "R_OO_Product_7pt",
            "R_OO_Taste",
            "R_OO_Taste_5pt",
            "R_FlavourThatILike",
            "R_FreshFeel",
            "R_LonglastFreshness",
            "R_CleanFeel",
            "R_PreventsCavitiesToothDecay",
            "R_FightsGerms",
            "R_OO_Packaging",
            "R_OO_Carton",
            "R_OO_Tube",
            "R_OO_Appear",
            "R_OO_Texture",
        ],
        customSubOrderUnileverFragranceHouse: [
            "R_OverallOpinionFrag",
            "R_OverallOpinionProduct",
            "R_OO_OverallOpinionOfFragJustSmelled",
            "R_OO_CleaningPerformanceOfLaundryDetergent",
            "R_OverallFragOpinionOnDampClothes",
            "R_OO_OverallOpinionOfFragOnDampClothes",
            "R_OO_OverallOpinionOfFragWhilistDryingClothes",
            "R_OverallFragOpinionOnDryClothes",
            "R_OO_OverallOpinionOfFragOnDryClothes",
            "R_OverallFragOpinionWhilistYouWoreThem",
            "R_OverallFragOpinionAfterSevenDays",
            "R_OO_OverallOpinionOfFragAfterSevenDays",
            "R_OO_OverallOpinionOfFragAtThisStage",
            "R_FragElevateExperienceOfDoingLaundry",
            "R_FragStrengthWhileClothesWereDrying",
        ],
    },
    // secondary: {
    //     customOrder: ["Odour", "Wetness", "Fragrance", "Stains", "Sensory & Application"],
    //     customOrderOralCare: ["Flavor / Taste", "Freshness", "Cooling", "Cleaning", "Protection / Strengthening", "Efficacy", "Suitability", "Any foam"],
    //     customOrderSkinCleansing: ["Product Suitability", "Sulphate Free"],
    // },
    agreement: {
        // customOrder: ["Efficacy", "Fragrance", "Sensory & Application", "Skin Care", "Stains", "Packaging"],
        // customOrderOralCare: ["Efficacy", "Fragrance", "Sensory & Application", "Skin Care", "Stains", "Packaging"],
        // customOrderSkinCleansing: [
        //     "Cleansing",
        //     "Lather",
        //     "Rinse Off",
        //     "Fragrance",
        //     "Better Fragrance",
        //     "Better Product",
        //     "Fragrance Fitment",
        //     "Fragrance Suitability",
        //     "Germ Protection",
        //     "Skin Protection",
        //     "Consistency",
        //     "Stickiness",
        //     "Enjoyability",
        //     "Long Lastingness",
        //     "Sog Mush",
        //     "Suitability",
        //     "Refreshed Feel",
        //     "Value for Money",
        //     "Moisturization",
        //     "Soft & Smooth Skin",
        //     "Skin Feel",
        //     "Skin Health",
        //     "High Quality Brand/Product",
        //     "Confidence",
        //     "Chemical Free",
        //     "Natural",
        //     "Product Fitment",
        //     "Packaging",
        // ],
        customSubOrderSkinCleansing: [
            "R_A_CleaneseSkinThoroughly",
            "R_A_GentlyCleansesSkin",
            "R_A_GivesSqueakyCleanFeel",
            "R_A_SqueakyCleanFeelingSkin",
            "R_A_ThoroughlyCleansesSkinAndHands",
            "R_A_LathersEasily",
            "R_A_ProvidesRightAmountOfLather",
            "R_A_ProvidesCreamyLather",
            "R_A_EasyToRinseOff",
            "R_A_HasPleasantFragrance",
            "R_A_FragranceFillsShoweringAndBathArea",
            "R_A_HasLongLastingFragrance",
            "R_A_BetterFragranceThanOtherBodyWash",
            "R_A_StrengthOfFragrance",
            "R_A_BetterFragranceThanOthers",
            "R_A_HasBetterFragranceThanOthers",
            "R_A_BetterProductThanOthers",
            "R_FragranceFitment",
            "R_A_OpinionOfFragranceSuitability",
            "R_A_ProtectsEffectievlyFromGerms",
            "R_A_ProtectsAgainstPollutionDustProblems",
            "R_A_ApplyingConsistencyILike",
            "R_A_NoStickyFeelingAfterApplying",
            "R_A_EnjoyableToUse",
            "R_A_LongLasting",
            "R_A_NotSoggyAndMushy",
            "R_A_SuitableForWholeFamily",
            "R_A_FeelsRefreshed",
            "R_A_ValueForMoney",
            "R_A_DoesNotDryOutMySkin",
            "R_A_DoesNotDryOutMySkinAndHands",
            "R_A_MoisturizesMySkin",
            "R_MoisturizationLasting",
            "R_A_MakesSkinNoticeablySoftAndSmooth",
            "R_A_MakesSkinSoftAndSmooth",
            "R_A_MakesMySkinSoftAndSmooth",
            "R_A_GentleAndMildOnMySkin",
            "R_A_BestSoapImprovesSkinHealth",
            "R_A_EffectivelyProtectsFromSkinProblems",
            "R_A_RenewedSkin",
            "R_A_HighQualityProduct",
            "R_A_IsHighQualityBrand",
            "R_A_InspiresWomenToExpressBeautyConfidently",
            "R_A_FreeFromHarshChemicals",
            "R_A_GivesExperienceOfNeemBath",
            "R_A_MoreNaturalThanOtherBrands",
            "R_A_NaturalProduct",
            "R_A_PackagingCuesNaturalProduct",
            "R_A_ProductFits",
            "R_A_GoodQualityPackaging",
            "R_A_PackagingPreservesProductWellDuringStorage",
        ],
    },
    // claims: {
    // customOrder: ["Overall", "Efficacy", "Fragrance", "Sensory & Application", "Stains", "Skin Care", "Packaging"],
    // },
    justRight: {
        customOrder: ["Overall", "Efficacy", "Fragrance", "Sensory & Application", "Stains", "Skin Care", "Packaging"],
        customOrderOralCare: ["Flavor / Taste", "Freshness", "Cooling", "Appearance", "Texture", "Any foam", "Other sensorial", "Others"],
    },
    fragranceMetrics: {
        customOrder: ["Fragrance Strength", "Body Odour"],
    },
    preference: {
        customOrder: ["Fragrance Strength", "Fragrance Freshness", "Armpit with least Body Odour", "Armpit most protected from Body Odour"],
    },
};

export default MacroCategoryOrder;
